import type {
  ChatbotAction,
  ChatbotMetric,
  StatusTone,
} from '../../../types/chatbot-message.types';
import { ActionButtonGroup } from '../action-button-group';

import { MetricRow } from './metric-row';
import { StatusBadge } from './status-badge';

interface RecommendationCardProps {
  /** Optional badge tone — used when the recommendation is also a status (e.g. "Input Needed"). */
  tone?: StatusTone | undefined;
  badge?: string | undefined;
  body?: string | undefined;
  subBody?: string | undefined;
  metrics?: ChatbotMetric[] | undefined;
  actions: ChatbotAction[];
  onAction?: ((id: ChatbotAction['id']) => void) | undefined;
}

/** Card containing an optional badge, recommendation paragraph, optional metrics, and a stack of action buttons. */
export function RecommendationCard({
  tone,
  badge,
  body,
  subBody,
  metrics,
  actions,
  onAction,
}: RecommendationCardProps) {
  return (
    <div className="space-y-3 rounded-xl border p-3">
      {tone && badge ? <StatusBadge tone={tone}>{badge}</StatusBadge> : null}
      {body ? <p className="text-foreground text-xs leading-5 font-medium">{body}</p> : null}
      {subBody ? <p className="text-muted-foreground text-xs leading-5">{subBody}</p> : null}
      {metrics && metrics.length > 0 ? (
        <div className="space-y-1.5">
          {metrics.map((metric, idx) => (
            <MetricRow key={`${metric.label}-${String(idx)}`} {...metric} />
          ))}
        </div>
      ) : null}
      <ActionButtonGroup actions={actions} onAction={onAction} />
    </div>
  );
}
